module.exports = __webpack_public_path__ + "89626c8137512b3fe2547dddbc27a2bf.pdf";